module.exports = __webpack_public_path__ + "img/frameCardTwo.157f41aa.png";